var map = {
	"./00_limit.json": "/ur1",
	"./01_connect.json": "wa9k",
	"./02_data_compress.json": "vuQY",
	"./03_heart_beat.json": "il07",
	"./04_subscribe.json": "n8XW",
	"./05_cancel_subscribe.json": "7k03"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hrXE";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/introduce \.json$
// module id = hrXE
// module chunks = 3